import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FieldConfig } from '../../_models/field.interface';
import { FidelidadeService } from '../../_services/fidelidade.service';

@Component({
  selector: 'app-desafios-detalhes',
  templateUrl: './desafios-detalhes.component.html',
  styleUrls: ['./desafios-detalhes.component.scss'],
})
export class DesafiosDetalhesComponent implements OnInit {
  regLabelMenuCacauLover: FieldConfig[] = [];
  regDesafioDetalhe: FieldConfig[] = [];
  desafioCompleto: boolean = false;

  carregandoDesafio: boolean = false;

  constructor(
    private loyalty: FidelidadeService,
    private location: Location,
    private router: Router,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {
      const idDesafio = params['idDesafio'];
      if (idDesafio !== undefined && idDesafio !== 0) {
        this.carregarDesafio(Number(idDesafio));
      }
    });
  }

  ngOnInit(): void {
    this.registrarElementosDaPagina();
  }

  registrarElementosDaPagina() {
    this.carregarHeader();
  }

  carregarHeader() {
    this.regLabelMenuCacauLover = [
      {
        type: 'labelImage',
        label: 'Desafios',
        icon: ['assets/images/icons/voltar.png'],
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '24px',
            color: '#461F1A',
            'padding-left': '50px',
            'padding-top': '19px',
          };
        },
        onClick: () => this.location.back(),
      },
    ];
  }

  carregarDesafio(idMembro: number) {
    this.carregandoDesafio = true;
    this.loyalty.obterDesafioPorId(idMembro).subscribe(
      (res) => this.processarSucessoCarregarDesafio(res),
      (err) => this.processarFalhaCarregarDesafio(err)
    );
  }

  processarSucessoCarregarDesafio(res: any) {
    const desafio = res;

    const labelStyle = () => {
      return {
        width: '80%',
        display: 'block',
        margin: 'auto',
        'text-align': 'center',
        'font-size': '0.9em',
        'margin-bottom': '8px',
      };
    };

    this.regDesafioDetalhe = [
      {
        type: 'image',
        src: this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpeg;base64,' + desafio.imagemTituloBase64
        ),
        style: () => {
          return {
            width: '100%',
            height: '300px',
            'object-fit': 'cover',
          };
        },
      },
      {
        type: 'image',
        src: this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpeg;base64,' + desafio.imagemLogoBase64
        ),
        style: () => {
          return {
            width: '250px',
            height: '100px',
            display: 'block',
            margin: '24px auto',
          };
        },
      },
      {
        type: 'label',
        label: desafio.nomeDesafio,
        style: () => {
          return {
            width: '100%',
            color: '#E5AE96',
            'font-weight': '700',
            'text-align': 'center',
            'font-size': '1.2em',
            'margin-bottom': '16px',
          };
        },
      },
      {
        type: 'label',
        label: desafio.titulo,
        style: labelStyle,
      },
      {
        type: 'label',
        label: desafio.descricao,
        style: labelStyle,
      },
      {
        type: 'label',
        label: desafio.mecanica,
        style: labelStyle,
      },
    ];

    const desafioCompleto =
      desafio.desafiosMembros[0]?.porcentagemFeita === 100 ? true : false;
    if (desafioCompleto) {
      this.regDesafioDetalhe.push({
        type: 'label',
        label: desafio.medalha,
        style: labelStyle,
      });
    }
    this.carregandoDesafio = false;
  }

  processarFalhaCarregarDesafio(err: any) {
    this.carregandoDesafio = false;
    console.error('Ocorreu um erro ao tentar obter o desafio', err);
  }
}
